import React, { FC, useContext, useEffect, useState } from 'react';
import {
  createStyles,
  withStyles,
  WithStyles,
} from '@material-ui/core/styles';
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Paper,
  Typography,
} from '@material-ui/core';
import { DropzoneAreaBase, FileObject } from 'material-ui-dropzone';

import { ProfileContext } from '@app/contexts/profile';

import TextField from '../common/text-field';
import { useEntityState } from '../../hooks/use-entity-state';
import api from '../../api/api';
import { useAlert } from '../../hooks/use-alert';

type FeedbackProps = WithStyles<typeof styles>;

type FeedbackFormInstance = {
  name?: string;
  phone?: string;
  email?: string;
  message?: string;
};

const Feedback: FC<FeedbackProps> = () => {
  const { info } = useAlert();
  const [files, setFiles] = useState<FileObject[]>([]);
  const [form, onChange, setInstance] = useEntityState<FeedbackFormInstance>(
    {}
  );
  const [isSending, setIsSending] = useState<boolean>(false);

  const { profile } = useContext(ProfileContext);

  const [validateState, setValidateState] = useState('');

  const onAdd = (files: FileObject[]) => {
    if (!files[0].data) {
      return;
    }

    setFiles(files);
  };

  useEffect(() => {
    setInstance({
      name: `${profile.first_name || ''} ${profile.last_name || ''} [${
        profile.username || 'не указан'
      }]`,
      email: profile.email || '',
      phone: profile.phone || '',
    });
  }, [profile, setInstance]);

  const send = async () => {
    if (!form.name || !form.email || !form.phone || !form.message) {
      setValidateState(
        'Не заполнено обязательное поле: ' +
          ((!form.name && 'имя') ||
            (!form.email && 'эл. почта') ||
            (!form.phone && 'телефон') ||
            (!form.message && 'сообщение'))
      );
      return;
    }
    setIsSending(true);
    await api.service.feedback({
      name: form.name,
      email: form.email,
      phone: form.phone,
      message: form.message,
      ...(files[0]
        ? {
            attachment: [
              {
                filename: files[0].file.name,
                content: files[0].data.toString(),
              },
            ],
          }
        : {}),
    });
    info('Сообщение отправлено');
    setInstance({
      name: '',
      email: '',
      phone: '',
      message: '',
    });
    setFiles([]);
    setValidateState('');
    setIsSending(false);
  };

  return (
    <Box paddingX={{ xs: 0, sm: 2, md: 10, lg: 14, xl: 20 }}>
      <Paper>
        <Box paddingX={2} paddingY={3}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Как к вам обращаться?"
                id="name"
                value={form.name}
                onChange={onChange('name')}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                label="Телефон"
                id="number"
                value={form.phone}
                onChange={onChange('phone')}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                label="Эл. почта"
                id="number"
                value={form.email}
                onChange={onChange('email')}
              />
            </Grid>
            <Grid item xs={12} />
            <Grid item xs={12}>
              <TextField
                id="comment"
                label="Сообщение"
                multiline
                rows={4}
                value={form.message}
                onChange={onChange('message')}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <DropzoneAreaBase
                fileObjects={files}
                dropzoneText="Переместите сюда файл/скриншот или нажмите для вызова диалога"
                onAdd={onAdd}
              />
            </Grid>
            {validateState && (
              <Grid item xs={12} sm={12}>
                <Typography color="secondary">{validateState}</Typography>
              </Grid>
            )}
            <Grid item xs={12}>
              <Box display="flex">
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  onClick={send}
                  disabled={isSending}
                >
                  Отправить
                </Button>
                {isSending && <CircularProgress />}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Box>
  );
};

const styles = () => createStyles({});

export default withStyles(styles)(Feedback);
